import { useTranslation, Trans } from "react-i18next";

import Button from "../Button";

import main from '../../img/Fees/main.png'
import main2 from '../../img/Fees/main2.png'

function Main() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[40px] xl:pt-[60px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <div className="flex flex-col xl:flex-row justify-between">
                <div className="flex flex-col items-start">
                    <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#FFF] xl:max-w-[600px]">
                        <Trans>{t("fees.1")}</Trans>
                    </p>
                    <p className="xl:max-w-[497px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">
                        {t("fees.2")}
                    </p>
                    <div className="flex items-center gap-[10px] mt-[20px] xl:mt-[30px]">
                        <div className="w-[4px] h-[4px] bg-[#FFFFFF] flex-shrink-0"></div>
                        <p className="ibm-plex font-[500] leading-[1.2] text-[#FFFFFF] text-[14px] xl:text-[16px]">{t("fees.3")}</p>
                    </div>
                    <div className="flex items-center gap-[10px] mt-[12px] xl:mt-[20px]">
                        <div className="w-[4px] h-[4px] bg-[#FFFFFF] flex-shrink-0"></div>
                        <p className="ibm-plex font-[500] leading-[1.2] text-[#FFFFFF] text-[14px] xl:text-[16px]">{t("fees.4")}</p>
                    </div>
                    <p className="xl:max-w-[497px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[20px] xl:mt-[30px]">
                        {t("fees.5")}
                    </p>
                </div>
                <img src={main} alt="" className="mt-[40px] xl:mt-0"/>
            </div>
            <div className="flex flex-col xl:flex-row-reverse justify-between pt-[80px]">
                <div className="flex flex-col items-start">
                    <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#FFF] xl:max-w-[505px]">
                        <Trans>{t("fees.6")}</Trans>
                    </p>
                    <p className="xl:max-w-[497px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">
                        {t("fees.2")}
                    </p>
                    <div className="flex mt-[30px] xl:mt-[40px] gap-[8px]">
                        <div className="w-[2px] h-[18px] bg-[#FFF] flex-shrink-0 xl:mt-[2px]"></div>
                        <div>
                            <p className="zen-dots leading-[1.2] text-[16px] xl:text-[20px] text-[#FFF] xl:max-w-[505px]">
                                <Trans>{t("fees.7")}</Trans>
                            </p>
                            <p className="xl:max-w-[487px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[12px]">
                                {t("fees.8")}
                            </p>
                        </div>
                    </div>
                    <div className="flex mt-[30px] xl:mt-[40px] gap-[8px]">
                        <div className="w-[2px] h-[18px] bg-[#FFF] flex-shrink-0 xl:mt-[2px]"></div>
                        <div>
                            <p className="zen-dots leading-[1.2] text-[16px] xl:text-[20px] text-[#FFF] xl:max-w-[505px]">
                                <Trans>{t("fees.9")}</Trans>
                            </p>
                            <p className="xl:max-w-[487px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[12px]">
                                {t("fees.10")}
                            </p>
                        </div>
                    </div>
                </div>
                <img src={main2} alt="" className="mt-[40px] xl:mt-0"/>
            </div>
        </div>
    </div>
  );
}

export default Main;
